import apiInstance from "../Api/ApiInstance";

export async function ClientRecovery(values) {
  const { email } = values;
  return await apiInstance.get(`api/nexus-main/user/client/recovery/${email}`);
}
